import React from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { UsersTableActionMenuItem } from '../../../modules/UsersTable/UsersTableActionMenuItem';
import { localise } from '../../../../services/lang/lang';
import { useManyDisclosureProxy } from '../../../../hooks/state/useManyDisclosureProxy';
import { RenderIf } from '../../../modules/RenderIf/RenderIf';
import { UserPermissionsModal } from '../../../modules/UserPermissionsModal/UserPermissionsModal';
import { PermissionGuard } from '../../../modules/PermissionGuard/PermissionGuard';
import { DeleteUserModal } from '../../../modules/DeleteUserModal/DeleteUserModal';
import { useSession } from '../../../../context/SessionProvider';
import { hasHigherRole } from '../../../../services/roles';
import { TableActionMenu } from '../../../modules/Table/TableActionMenu';
export const ActiveUsersTableMenuOptions = (props) => {
    const sessionUser = useSession();
    const shouldShowDelete = sessionUser.id !== props.user.id &&
        hasHigherRole(sessionUser.roles, props.user.roles);
    const { buildOnClose, isOpen, buildOnOpen, onClose } = useManyDisclosureProxy({
        assignPermissions: useDisclosure(),
        delete: useDisclosure(),
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(PermissionGuard, { permissions: ['users.set-roles', 'users.delete'], strategy: "any" },
            React.createElement(TableActionMenu, null,
                React.createElement(PermissionGuard, { permissions: ['users.set-roles'] },
                    React.createElement(UsersTableActionMenuItem, { onClick: buildOnOpen('assignPermissions') }, localise('ASSIGN_PERMISSIONS'))),
                React.createElement(PermissionGuard, { overrideCondition: !shouldShowDelete, permissions: ['users.delete'] },
                    React.createElement(UsersTableActionMenuItem, { onClick: buildOnOpen('delete') }, localise('DELETE_USER'))))),
        React.createElement(RenderIf, { condition: isOpen('assignPermissions') },
            React.createElement(UserPermissionsModal, { user: props.user, isOpen: true, onClose: buildOnClose('assignPermissions'), onChange: () => {
                    onClose('assignPermissions');
                    if (props.onChange) {
                        props.onChange();
                    }
                } })),
        React.createElement(RenderIf, { condition: isOpen('delete') },
            React.createElement(DeleteUserModal, { onClose: buildOnClose('delete'), onDeleted: () => {
                    onClose('delete');
                    props.onChange?.();
                }, user: props.user }))));
};
